/**
 * Keyboard utilities for cross-platform shortcut handling
 */

// Detect if user is on Mac
export const isMac = (): boolean => {
  if (typeof window === 'undefined') return false;
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
};

// Get the modifier key symbol based on OS
export const getModifierKey = (): string => {
  return isMac() ? '⌘' : 'Ctrl';
};

// Format shortcut for display based on OS
// Converts ⌘ to the appropriate modifier key for the current platform
export const formatShortcut = (shortcut: string): string => {
  if (!shortcut) return '';

  // Replace ⌘ with appropriate modifier
  return shortcut.replace('⌘', getModifierKey());
};
